export const BUY_TICKETS_URL = "https://ploughingmatch.ticketsrv.co.uk/tickets/28";

export function getNextEventDate() {
  const eventDate = getCurrentEventDate();  
  const today = new Date();
  const year = today.getFullYear();
  if (eventDate < today) {
    return getCurrentEventDate(year + 1);
  }
  return eventDate;
}

export function getCurrentEventDate(year = new Date().getFullYear()) {
    // Last Saturday in September
  const lastDayOfSeptember = new Date(year, 8, 30); // September 30th
  const dayOfWeek = lastDayOfSeptember.getDay(); // 0=Sun, ..., 6=Sat
  // Calculate how many days to subtract to get to the previous Saturday and set time to 17:00 of last saturday
  const lastSaturday = new Date(year, 8, 30 - ((dayOfWeek + 1) % 7), 17, 0, 0);
  return lastSaturday;
}

export function formatEventDate(date) {
  return date.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}

export function shouldShowTicketsButton() {
  const now = new Date();
  const nextEventDate = getNextEventDate();
  const eventYear = nextEventDate.getFullYear();
  const showFrom = new Date(eventYear, 6, 1); // July is month 6 (0-indexed)
  // Set event cutoff to 15:00 on the event day
  const eventCutoff = new Date(nextEventDate);
  eventCutoff.setHours(15, 0, 0, 0);

  return now >= showFrom && now < eventCutoff;
}

export function shouldShowSection(startDateStr, endDateStr) {
  const now = new Date();
  const startDate = new Date(startDateStr);
  const endDate = endDateStr
    ? new Date(endDateStr)
    : getCurrentEventDate(startDate.getFullYear());
  return now >= startDate && now <= endDate;
}

const eventDetails = {
  2027: {
    location: "Little Faringdon Road, Langford, GL7 3LA",
    permission: "AJ Cole & Son and Mr P Kirby",
    lng: -1.647817,
    lat: 51.720989,
  },
  2026: {
    location: "Red Barn, Ashbury, SN6 8LZ",
    permission: "Mr T Spence",
    w3w: "wages.view.plod",
    lng: -1.6002843,
    lat: 51.551716,
  },
  2025: {
    location: "Barrington Park Estate, OX18 4TN ",
    permission: "Mr R Wingfield",
    lng: -1.708818,
    lat: 51.806320,
  },
};

const membershipDetails = {
  single: {
    description:
      "One Admission Badge, forward parking for one car, programme and admission to the Members Tent.",
    price: "25",
  },
  single_OAP: {
    description:
      "One Admission Badge, forward parking for one car, programme and admission to the Members Tent.",
    price: "20",
  },
  joint: {
    description:
      "Two Admission Badges, forward parking for one car, programme and admission to the Members Tent.",
    price: "45",
  },
  joint_OAP: {
    description:
      "Two Admission Badges, forward parking for one car, programme and admission to the Members Tent.",
    price: "40",
  },
  family: {
    description:
      "Two Adult Admission Badges, Two Children's Admission Badges, forward parking for one car, programme and admission to the Members Tent.",
    price: "60",
  },
  company: {
    description:
      "Three Adult Admission Badges, forward parking for one car, programme and admission to the Members Tent.",
    price: "60",
  },
};

function getNextEventYear() {
  const nextEventDate = getNextEventDate();
  return nextEventDate.getFullYear();
}

export function getEventLocation() {
  const year = getNextEventYear();
  if (eventDetails[year] && eventDetails[year].location) {
    return "at " + eventDetails[year].location;
  }
  return null;
}

export function getEventPermission() {
  const year = getNextEventYear();
  if (eventDetails[year] && eventDetails[year].permission) {
    return "by kind permission of " + eventDetails[year].permission;
  }
  return null;
}

export function getEventLatLng() {
  const year = getNextEventYear();
  if (eventDetails[year] && eventDetails[year].lat && eventDetails[year].lng) {
    return {
      lat: eventDetails[year].lat,
      lng: eventDetails[year].lng,
    };
  }
  return null;
}

export function getEventW3w() {
  const year = getNextEventYear();
  if (eventDetails[year] && eventDetails[year].w3w) {
    return eventDetails[year].w3w;
  }
  return null;
}

export function getMembershipDetails() {
  return membershipDetails;
}